import {NgModule} from '@angular/core';
import {FormsModule} from "@angular/forms";
import {CommonModule} from "@angular/common";
import {FangSearchComponent} from "./fang-search.component";

@NgModule({
	imports: [
		CommonModule,
		FormsModule
	],
	exports: [
		FangSearchComponent
	],
	declarations: [
		FangSearchComponent
	],
	providers: [],
	entryComponents: [FangSearchComponent]
})
export class FangSearchModule {
}
